function getReferralKeyFromUrl(): string | undefined {
  return window.location.pathname
    .split('/')
    .find((part) => part.toUpperCase().includes('RFID'));
}

export { getReferralKeyFromUrl };
